// @flow
import React, { Component } from 'react';
import styled from 'styled-components';

import Button from 'bs/Button';
import Col from 'bs/Col';


export const StyledButton = styled.div`
    .btn {}
`;

type AddCardProps = {
    onClick: ?void,
    label?: string
}

export class AddCard extends Component<AddCardProps> {

    render() {

        const onClick = this.props.onClick;

        return (
            <StyledButton className='row'>
                <Col>
                    <Button flavor="default" onClick={onClick}><i className='icon icon-plus'></i> {this.props.label}</Button>
                </Col>
            </StyledButton>
        );
    }
}

export default AddCard;
